<template>
  <PopoverRight ref="popoverMenu" width="550px">
    <div class="popover-slider-bar">
      <h1 class="bar-title">{{title}}广告位</h1>
      <el-form
        class="form-container"
        :model="locationInfo"
        :rules="locationRules"
        ref="locationInfo"
      >
        <div class="form-item">
          <div class="form-label">
            <span class="label">广告位名称</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="name">
              <el-input placeholder="请输入广告位名称" v-model="locationInfo.name"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">客户端</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="terminal_id">
              <el-select v-model="locationInfo.terminal_id" @change="getPages">
                <el-option
                  v-for="(item, key) in terminals"
                  :value="item.id"
                  :label="item.name"
                  :key="key"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">广告页面</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="ad_page_id">
              <el-select v-model="locationInfo.ad_page_id">
                <el-option
                  v-for="(item, key) in pages"
                  :value="item.id"
                  :label="item.name"
                  :key="key"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">宽度（px）</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="width">
              <el-input placeholder="请输入广告位宽度" v-model="locationInfo.width" type='number'></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">高度（px）</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item label prop="height">
              <el-input placeholder="请输入广告位高度" v-model="locationInfo.height" type='number'></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">限制大小（kb）</span>
          </div>
          <div class="form-input-item">
            <el-form-item label>
              <el-input  v-model="locationInfo.size" type='number' ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">是否支持广告轮播</span>
          </div>
          <div class="form-input-item">
            <el-form-item label>
              <el-select v-model="locationInfo.type">
                  <el-option
                    v-for="item in type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item" v-if="locationInfo.type==1">
          <div class="form-label">
            <span class="label">广告轮播间隔（s）</span>
          </div>
          <div class="form-input-item">
            <el-form-item label>
              <el-input placeholder="请输入轮播间隔时间" v-model="locationInfo.interval" type='number'></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">广告展示上限</span>
          </div>
          <div class="form-input-item">
            <el-form-item label>
              <el-input placeholder="请输入广告展示上限" v-model="locationInfo.number" type='number'></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-button">
          <el-button type="primary" @click="submitForm('locationInfo')">确 认</el-button>
          <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
        </div>
      </el-form>
    </div>
  </PopoverRight>
</template>

<script>
import { validateNumber } from "@/utils/validate";
import PopoverRight from "@/components/popoverRight/index";
import { createPosition, changePosition, getPagesList } from "@/service/ad";
export default {
  name: "add",
  components: {
    PopoverRight
  },
  props: {
    callback: Function
  },
  data() {
    return {
      title: "",
      locationInfo: {
        id: 0,
        name: null,
        type: 0,
        terminal_id: null,
        ad_page_id: null,
        width: null,
        height: null,
        size: '150',
        interval: '5',
        number: '1'
      },
      type:[
        {label:'不支持',value:0},
        {label:'支持',value:1}
      ],
      terminals: null,
      pages: null,
      locationRules: {
        name: [
          { required: true, message: "请填广告位名称", trigger: "blur" },
          { min: 1, max: 16, message: "长度在 1 到 16个字符", trigger: "blur" }
        ],
        terminal_id: [
          { required: true, message: "请选择客户端", trigger: "change" }
        ],
        ad_page_id: [
          { required: true, message: "请选择页面", trigger: "change" }
        ],
        width: [{ required: true, message: "请填广告位宽度", trigger: "blur" }],
        height: [
          { required: true, message: "请填广告位高度", trigger: "blur" }
        ],
        // size:[{ required: true, message: "请填限制大小", trigger: "blur" }],
        // number: [
        //     {  required: true, message: "请填广告上限", trigger: "blur" }
        // ],
      }
    };
  },
  methods: {
    getPages(val) {
      this.locationInfo.ad_page_id = null;
      let query = {};

      query["terminal_id"] = val;

      getPagesList(query).then(data => {
        this.pages = data.data;
      });
    },
    async open() {
      this.$refs.locationInfo && this.$refs.locationInfo.clearValidate();
      this.$refs.popoverMenu && this.$refs.popoverMenu.open();
    },
    /** 关闭右侧悬浮层 */
    hide() {
      this.resetForm();
      this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
      this.$refs.locationInfo && this.$refs.locationInfo.clearValidate();
    },
    resetForm() {
      this.locationInfo = {
        id: 0,
        name: null,
        type: 0,
        terminal_id: null,
        ad_page_id: null,
        width: null,
        height: null,
        size: 150,
        interval: 5,
        number: 1
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let query = this.locationInfo;
          query.terminal_name = this.terminals.find(
            ele => ele.id === this.locationInfo.terminal_id
          ).name;
          query.ad_page_name = this.pages.find(
            ele => ele.id === this.locationInfo.ad_page_id
          ).name;
          if (this.title == "新增") {
            createPosition(query)
              .then(data => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                  duration: 3 * 1000
                });
                this.hide();
                this.callback && this.callback();
              })
              .catch(err => {
                this.$message({
                  message: err.message || "添加失败",
                  type: "error",
                  duration: 3 * 1000
                });
              });
          }else{
               changePosition(this.locationInfo.id,query)
              .then(data => {
                this.$message({
                  message: "修改成功",
                  type: "success",
                  duration: 3 * 1000
                });
                this.hide();
                this.callback && this.callback();
              })
              .catch(err => {
                this.$message({
                  message: err.message || "修改失败",
                  type: "error",
                  duration: 3 * 1000
                });
              });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.popover-slider-bar .form-container .form-item .form-label {
  width: 28% !important;
}
.popover-slider-bar .form-container .form-item .form-input-item {
  width: 72% !important;
}
</style>
